const PREFIX = '@@PAGES';
export const FETCHED_PAGES = `${PREFIX}/FETCHED_PAGES`;
export const LOADING_PAGES = `${PREFIX}/LOADING_PAGES`;
